import { Stack } from '@ui-components/neo.tax';

import { RightColumnCard } from '../right-column-card';
import { FormSectionConfiguration } from './forms.types';
import { FormSectionRecursive } from './FormSectionRecursive';

interface SectionFormsProps {
  section: FormSectionConfiguration;
}

export const FormSections = ({ section }: SectionFormsProps): React.ReactElement => (
  <RightColumnCard direction="column" boxShadow="base">
    {section.forms.map((form) =>
      Array.isArray(form) ? (
        <Stack key={section.title} direction="row" alignItems="start" justifyContent="space-between" gap={8}>
          {form.map((childForm) => (
            <FormSectionRecursive key={childForm.key} form={childForm} />
          ))}
        </Stack>
      ) : (
        <FormSectionRecursive key={form.key} form={form} />
      ),
    )}
  </RightColumnCard>
);
